var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#012234"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#2C5369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.4167C15 19.2191 15 17.6203 15.3775 17.0824C15.755 16.5445 17.2583 16.03 20.2649 15.0008L20.8377 14.8047C22.405 14.2682 23.1886 14 24 14C24.8114 14 25.595 14.2682 27.1623 14.8047L27.7351 15.0008C30.7417 16.03 32.245 16.5445 32.6225 17.0824C33 17.6203 33 19.2191 33 22.4167C33 22.8996 33 23.4234 33 23.9914C33 29.6294 28.761 32.3655 26.1014 33.5273C25.38 33.8424 25.0193 34 24 34C22.9807 34 22.62 33.8424 21.8986 33.5273C19.239 32.3655 15 29.6294 15 23.9914C15 23.4234 15 22.8996 15 22.4167Z",
    stroke: "#EBF0F3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.5502L24.6 21.0002C24.2444 20.7336 23.7556 20.7336 23.4 21.0002L20 23.5502M26 26.0502L24 24.5502L22 26.0502",
    stroke: "#EBF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalDark);
export default __webpack_public_path__ + "static/media/legalDark.cc88b35ff9447b6c38f2ca7430fe138c.svg";
export { ForwardRef as ReactComponent };